<template>
  <v-text-field
    v-bind="$attrs"
    v-model="value"
    :error-messages="errorMessage"
    masked="false"
    variant="outlined"
    class="custom-text-field"
    @blur="handleChange"
  >
    <template
      v-if="required"
      #prepend-inner
    >
      <span class="sz-red--text">*</span>
    </template>
  </v-text-field>
</template>

<script setup lang="ts">
import { useField, type RuleExpression } from 'vee-validate';
import { defineProps, toRef } from 'vue';

type Props = {
    rules: RuleExpression<unknown>;
    required?: boolean;
    name: string;
    modelValue: string;
    validateOnValueUpdate?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
    validateOnValueUpdate: false
});

const rulesRef = toRef(props, 'rules');

const { value, errorMessage, handleChange } = useField(() => props.name, rulesRef, {
    syncVModel: true,
    validateOnValueUpdate: props.validateOnValueUpdate
});

</script>

<style lang="scss">
@use '@/assets/css/variables.scss' as variables;

.custom-text-field {
  @media screen and (min-width: map-get(variables.$grid-breakpoints, 'md')) {
    min-width: 450px;
  }
  .v-input__details {
    min-height: 0;
  }
}
</style>
